
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

interface NocheLogoProps {
  collapsed?: boolean;
}

export const NocheLogo = ({ collapsed = false }: NocheLogoProps) => {
  const [isScrolled, setIsScrolled] = useState(false);
  
  useEffect(() => {
    // Add scroll event listener
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50); // Show/hide based on scroll position
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll); // Clean up event listener
    };
  }, []);
  
  return (
    <Link 
      to="/"
      className={`font-heading font-bold flex items-center justify-center gap-2 transition-colors duration-300 
        active:scale-95 touch-manipulation ${
        collapsed ? 'justify-center' : ''
      }`}
    >
      {collapsed ? (
        <span className="text-white bg-gradient-to-r from-purple-500 to-pink-600 p-1.5 rounded flex-shrink-0 min-w-[26px] min-h-[26px] flex items-center justify-center font-heading">
          NL
        </span>
      ) : (
        <span className={`text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-neon-purple to-neon-pink tracking-tight transition-opacity duration-300 ${isScrolled ? 'opacity-0' : 'opacity-100'} font-heading letter-spacing-tight`}>
          NocheLoco
        </span>
      )}
    </Link>
  );
};
